window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('product-card').forEach((productCard) => {
    productCard.addEventListener('variant:update', (eventsl) => {

      // tstodo
      // const featuredMediaPos = event.detail.resource.featured_media.position - 1;

      // const slides = productCard.querySelectorAll('slideshow-slide');
      // slides.forEach((s,idx) => {
      //     s.hidden = idx < featuredMediaPos || idx >= featuredMediaPos + 3;
      // });

    });
  });
});